import React, { PureComponent } from 'react'

const LAYOUT_MAX = 3

const styleTable = {
  borderCollapse: 'collapse',
  width: `${LAYOUT_MAX * 25}px`,
  height: `${LAYOUT_MAX * 25}px`,
}

const styleTableTd = {
  width: '25px',
  height: '25px',
  border: 'solid 1px #666',
  backgroundColor: '#444444',
  cursor: 'pointer',
}

class LayoutTool extends PureComponent {
  constructor(props) {
    super(props)
    this.tableRef = React.createRef()
    this.state = {
      row: Math.min(LAYOUT_MAX - 1, Math.max(0, this.props.row || 0)),
      col: Math.min(LAYOUT_MAX - 1, Math.max(0, this.props.col || 0)),
    }
  }

  componentDidMount() {
    this.paintHighlight(this.state.row, this.state.col)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.row !== this.props.row || prevProps.col !== this.props.col) {
      const row = Math.min(LAYOUT_MAX - 1, Math.max(0, this.props.row || 0))
      const col = Math.min(LAYOUT_MAX - 1, Math.max(0, this.props.col || 0))
      this.setState({ row, col }, () => this.paintHighlight(row, col))
    }
  }

  paintHighlight = (row, col) => {
    const table = this.tableRef.current
    if (!table || !table.rows) return
    for (let i = 0; i < LAYOUT_MAX; i++) {
      for (let j = 0; j < LAYOUT_MAX; j++) {
        const cell = table.rows[i] && table.rows[i].cells[j]
        if (!cell) continue
        cell.style.backgroundColor =
          i <= row && j <= col ? '#AAAAAA' : '#444444'
      }
    }
  }

  cellClick = (e) => {
    const row = e.target.parentNode.rowIndex
    const col = e.target.cellIndex
    this.setState({ row, col })
    this.paintHighlight(row, col)
    this.props.onChange(row + 1, col + 1)
  }

  renderTable() {
    const rows = Array.from({ length: LAYOUT_MAX })
    return rows.map((_, i) => (
      <tr key={`layout-row-${i}`}>
        {Array.from({ length: LAYOUT_MAX }).map((__, j) => (
          <td
            key={`layout-cell-${i}-${j}`}
            style={styleTableTd}
            onClick={this.cellClick}
          />
        ))}
      </tr>
    ))
  }

  render() {
    return (
      <div>
        <table style={styleTable} ref={this.tableRef}>
          <tbody>{this.renderTable()}</tbody>
        </table>
      </div>
    )
  }
}

export default LayoutTool
